import React, { useCallback, useEffect } from 'react';
import styled, { useTheme } from 'styled-components/native';
import { StatusBar } from 'react-native';
import { Box } from '@/components/base/box';
import { AppTextView } from '@/components/base/app.text.view';
import { useAppDispatch, useAppSelector } from '@/hooks/use.redux';
import { actionRemoveAlert } from '@/redux';
import { AppPressable } from '@/components/base/app.pressable';

export function GlobalAlert() {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const alerts = useAppSelector((state) => state.generalReducer.alerts).filter((alert) => alert.type === 'quick');
  const currentAlert = alerts[0];

  const onRemove = useCallback(() => {
    if (!currentAlert) {
      return;
    }
    dispatch(actionRemoveAlert(currentAlert.id));
  }, [currentAlert, dispatch]);

  useEffect(() => {
    if (!currentAlert) {
      return;
    }
    const id = setTimeout(onRemove, 5000);
    return () => {
      clearTimeout(id);
    };
  }, [currentAlert, onRemove]);

  if (!currentAlert) return null;

  const modeColors = {
    error: theme.colors.modal.error,
    warn: theme.colors.modal.warn,
    info: theme.colors.modal.info,
  };

  return (
    <AlertContainer fullWidth $top={StatusBar.currentHeight ?? 0}>
      <AlertPressable onPress={onRemove} $bgColor={modeColors[currentAlert.mode]}>
        <AppTextView textColor={'white'} text={currentAlert.message} variant={'primary'} textAlign={'center'} />
      </AlertPressable>
    </AlertContainer>
  );

  /* return (
    <Modal transparent visible onRequestClose={onRemove}>
      <AppPressable
        onPress={onRemove}
        style={{
          width: '100%',
          height: hp(3.8),
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: modeColors[currentAlert.mode],
          minHeight: 30,
          marginTop: StatusBar.currentHeight,
        }}
      >
        <AppTextView textColor={'white'} text={currentAlert.message} variant={'primary'} />
      </AppPressable>
    </Modal>
  );*/
}

const AlertContainer = styled(Box)<{ $top: number }>`
  position: absolute;
  top: ${({ $top }) => $top}px;
  height: 200px;
  width: 100%;
  z-index: 9999;
  align-items: center;
`;

const AlertPressable = styled(AppPressable)<{ $bgColor: string }>`
  width: 100%;
  height: ${({ theme }) => theme.hp(3.8)}px;
  align-items: center;
  justify-content: center;
  background-color: ${({ $bgColor }) => $bgColor};
  position: absolute;
  min-height: 30px;
  top: 0;
`;
